import invariant from "tiny-invariant";

import FillFieldsStep from "./components/FillFieldsStep";
import SelectLeadsTypeStep from "./components/SelectTypeStep";
import Step from "./enum/Step";

const steps = [SelectLeadsTypeStep, FillFieldsStep];

invariant(steps.length === Object.values(Step).length / 2); // div by 2 because enums have keys to do back conversion too

export default steps;
